import { getCurrentUser } from '../auth';

interface NavLink {
  hash: string;
  label: string;
  icon: string;
}

interface NavSection {
  title: string;
  links: NavLink[];
}

const sections: NavSection[] = [
  {
    title: 'OVERVIEW',
    links: [
      { hash: '#/dashboard', label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0h4' },
      { hash: '#/properties', label: 'Properties', icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4' },
    ],
  },
  {
    title: 'ACTION REQUIRED',
    links: [
      { hash: '#/financials', label: 'Financials', icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
      { hash: '#/maintenance', label: 'Maintenance', icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z' },
      { hash: '#/insurance', label: 'Insurance', icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' },
      { hash: '#/compliance', label: 'Compliance', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4' },
      { hash: '#/reminders', label: 'Reminders', icon: 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9' },
    ],
  },
  {
    title: 'RESOURCES',
    links: [
      { hash: '#/inbound-emails', label: 'Emails', icon: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
      { hash: '#/propertyme', label: 'PropertyMe Sync', icon: 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15' },
      { hash: '#/tradesmen', label: 'My Tradies', icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z' },
      { hash: '#/settings', label: 'Settings', icon: 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4' },
    ],
  },
];

const adminLinks: NavLink[] = [
  { hash: '#/admin/users', label: 'Users', icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' },
];

export function createSidebar(): HTMLElement {
  const user = getCurrentUser();
  const isAdmin = user?.role === 'admin';

  const nav = document.createElement('nav');
  nav.id = 'sidebar';
  nav.className = 'fixed lg:static inset-y-0 left-0 z-40 w-64 bg-card border-r border-gray-200 transform -translate-x-full lg:translate-x-0 transition-transform duration-200 pt-16 lg:pt-0';

  const inner = document.createElement('div');
  inner.className = 'flex flex-col h-full py-4 overflow-y-auto';

  const linkHtml = (l: NavLink) => `
    <a href="${l.hash}" class="nav-link ${isActive(l.hash) ? 'active' : ''}" data-nav="${l.hash}">
      <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="${l.icon}"/></svg>
      <span>${l.label}</span>
    </a>`;

  const sectionHtml = (s: NavSection) => `
    <div class="mb-2">
      <div class="px-4 py-2 text-xs font-semibold tracking-wider text-gray-400 uppercase">${s.title}</div>
      ${s.links.map(linkHtml).join('')}
    </div>`;

  let html = sections.map(sectionHtml).join('');

  if (isAdmin) {
    html += `
      <div class="mb-2">
        <div class="px-4 py-2 text-xs font-semibold tracking-wider text-gray-400 uppercase">Admin</div>
        ${adminLinks.map(linkHtml).join('')}
      </div>`;
  }

  inner.innerHTML = html;
  nav.appendChild(inner);

  // Overlay for mobile
  const overlay = document.createElement('div');
  overlay.id = 'sidebar-overlay';
  overlay.className = 'fixed inset-0 bg-black/30 z-30 hidden lg:hidden';

  // Update active state on hash change
  const updateActive = () => {
    inner.querySelectorAll('[data-nav]').forEach(el => {
      const href = el.getAttribute('data-nav')!;
      el.classList.toggle('active', isActive(href));
    });
    // Close sidebar on mobile after navigation
    nav.classList.add('-translate-x-full');
    overlay.classList.add('hidden');
  };
  window.addEventListener('hashchange', updateActive);

  // Wire up toggle
  setTimeout(() => {
    const toggle = document.getElementById('sidebar-toggle');
    if (toggle) {
      toggle.addEventListener('click', () => {
        nav.classList.toggle('-translate-x-full');
        overlay.classList.toggle('hidden');
      });
    }
    overlay.addEventListener('click', () => {
      nav.classList.add('-translate-x-full');
      overlay.classList.add('hidden');
    });
  });

  const wrapper = document.createElement('div');
  wrapper.appendChild(overlay);
  wrapper.appendChild(nav);
  return wrapper;
}

function isActive(hash: string): boolean {
  const current = window.location.hash || '#/dashboard';
  if (hash === '#/dashboard') return current === hash || current === '#/' || current === '#';
  return current.startsWith(hash);
}
